import { createFileRoute } from "@tanstack/react-router";
import { requerirEdicionDeSolicitud } from "@/features/solicitudes/utils/guard-edicion";
import { DocumentosPage } from "@/features/documentos/components/DocumentosPage";
import { solicitudQueryOptions } from "@/features/solicitudes/hooks/use-solicitud";
import { ErrorAlert, WizardPasoSkeleton } from "@/components/ui";

export const Route = createFileRoute("/_authed-tw/solicitudes/$id/documentos")({
  beforeLoad: requerirEdicionDeSolicitud,
  loader: ({ context: { queryClient }, params: { id } }) => queryClient.ensureQueryData(solicitudQueryOptions(id)),
  component: DocumentosPage,
  pendingComponent: WizardPasoSkeleton,
  errorComponent: ({ error }) => <ErrorAlert error={error} />,
});
